import {
  Button,
  Col,
  Form,
  FormControl,
  InputGroup,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'react-bootstrap';
import marketSignalApi from '@/modules/market-signals/api/market-signal-api';
import MarketSignalStreamSelector from '@/modules/market-signals/components/market-signals/market-signal-stream-selector';
import { useContext, useEffect, useState } from 'react';
import { MarketSignalContext } from '@/modules/market-signals/contexts/market-signal-context';
import { MarketSignalAssistantResponse } from '@/modules/market-signals/model/market-signals/market-signal-assistant-response';
import MarketSignalScrollerEntry from '@/modules/market-signals/components/market-signals/scroller/market-signal-scroller-entry';
import { Loading } from '@/shared/components/export';

export default function MarketSignalAssistant({
  show,
  onClose,
  question,
}: {
  show: boolean;
  onClose: () => void;
  question?: string;
}) {
  const { selectedStream } = useContext(MarketSignalContext);

  const [response, setResponse] = useState<MarketSignalAssistantResponse>();
  const [q, setQ] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(
    () => {
      if (show && question) {
        setQ(question);
        runQuery(question);
      }
    },
    [show, question], //eslint-disable-line
  );

  const runQuery = (q: string) => {
    setResponse(undefined);
    setLoading(true);
    if (selectedStream)
      marketSignalApi
        .queryAssistant(selectedStream, q)
        .then(setResponse)
        .finally(() => {
          setLoading(false);
        });
  };

  useEffect(() => {
    console.log(response?.responseText);
  }, [response]);

  return (
    <Modal show={show} size={'lg'} onBackdropClick={onClose} onHide={onClose}>
      <ModalHeader>
        <div className={'d-flex w-100 justify-content-between align-items-center'}>
          <div className={'h3'}>Market Signal Assistant</div>
          <Button onClick={onClose} variant={'warning'}>
            Close
          </Button>
        </div>
      </ModalHeader>

      <ModalBody>
        <Form
          onSubmit={event => {
            event.stopPropagation();
            event.preventDefault();
            runQuery(q);
          }}
        >
          <InputGroup size={'sm'} className={'mb-1'}>
            <MarketSignalStreamSelector />
          </InputGroup>

          <InputGroup size={'sm'} className={'mb-3'}>
            <FormControl
              type={'text'}
              placeholder={'Ask a question here'}
              value={q}
              onChange={event => setQ(event.target.value)}
            ></FormControl>
          </InputGroup>
        </Form>

        {loading && (
          <div className={'m-5'}>
            <Loading />
          </div>
        )}

        {response && (
          <Row>
            <Col md={6}>
              <h5>Result:</h5>
              <pre className={'text-break'} style={{ whiteSpace: 'pre-wrap' }}>
                {response?.responseText}
              </pre>
            </Col>
            <Col>
              <h5>Sources:</h5>

              {response?.referencedItems.map(value => (
                <div className={'small mb-3'}>
                  <MarketSignalScrollerEntry signal={value} />
                </div>
              ))}
            </Col>
          </Row>
        )}

        {!response && !loading && (
          <div className={'m-4 text-center text-muted opacity-25'}>
            <h2>Entry a query above</h2>
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}
